import {View} from "@lernetz/ts-lib";
import {gateway} from "../../services/gateway";
import {languageService} from "../../services/lang";
import template from "./footer.component.html";

export class FooterView extends View {
    footer: {address: string;};
    constructor() {
        super({template, data: {lang: languageService.currentLang}});
        gateway.loadGeneralInfos().then(generalInfos => {
            this.data.footer = {
                'address': generalInfos.footerAddress,
            };
        });
    }
}
